export default __webpack_public_path__ + "static/media/mccree.5ddc6093.webp";